import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { hot } from "react-hot-loader/root";
import { ConfigProvider } from "antd";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { Platform, Auth, PaymentResult } from "./components";
import "./index.less";
import { useStores } from "./store";
import { Restaurant } from "./pages";
import matomo from './service/matomo'

import {
  BackIcon,
  TipIcon,
  CopyIcon,
  BookingIcon,
  VipIcon,
  DeleteIcon,
} from "./components";

function App() {
  const { memberStore } = useStores();
  const locale = memberStore.getLocale();
  return (
    <Auth>
      <Router>
        <ConfigProvider locale={locale}>
          <div className="page-main">
            <main>
              <Switch>
                <Route path="/restaurants/:id" component={Restaurant}></Route>
                <Route path="/paymentResult/:paymentStr" component={PaymentResult}></Route>
              </Switch>
            </main>
            <Platform></Platform>
          </div>
        </ConfigProvider>
      </Router>
    </Auth>
  );
}

async function bootstrap() {
  const WithHotReload = process.env.NODE_ENV === "production" ? App : hot(App);
  ReactDOM.render(<WithHotReload />, document.getElementById("root"));
}
matomo()
bootstrap();